import { defineComponent, h } from 'vue';
import { Vue } from '@/Shared/vueCompat.js';
import { QInput } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import careHelpfulFunctions from '../careHelpfulFunctions.jsx';

import utils from '../../Shared/utils.jsx';
import methods from '../../Shared/methods';

export default defineComponent({
    name: 'basic-input',
    mixins: [BaseComponent],
    components: { QInput },
    data: function () {
        return {
            typeEval: null,
            textEval: null,
            placeholderEval: null,
            setValueFunction: null,
            isDisabledEval: null,
            model: ''
        }
    },
    props: {},
    created() {
        if(this.text)
            this.publishField = this.text;
    },
    //Mounted Replaced with preRenderComplete
    computed: {
        inputType() {
            try {
                if(this.typeEval === null && this.controlData.Type)
                    this.typeEval = utils.compile(this, this.controlData.Type);
                let type = 'text';
                if(this.typeEval)
                    type = utils.evaluate(this.typeEval, this);
                if (type != null && typeof type === 'string') {
                    const normalized = type.toLowerCase().trim();
                    if (normalized === 'password') return 'password';
                    if (['text', 'search', 'url', 'tel', 'number', 'email'].includes(normalized)) return normalized;
                }
                return 'text';
            }
            catch (e) {
                utils.warn('Type could not evaluate expression: ' + this.controlData.Type + '; ' + e);
                return 'text';
            }
        },
        text() {
            try {
                if(this.textEval === null && this.controlData.Text)
                    this.textEval = utils.compile(this, this.controlData.Text);
                if(this.textEval)
                    return utils.evaluate(this.textEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Text could not evaluate expression: ' + this.controlData.Text + '; ' + e);
                return '';
            }
        },
        placeholder() {
            try {
                if(this.placeholderEval === null && this.controlData.PlaceHolder)
                    this.placeholderEval = utils.compile(this, this.Translate(this.controlData.PlaceHolder));
                if(this.placeholderEval)
                    return utils.evaluate(this.placeholderEval, this);
                return '';
            }
            catch (e) {
                utils.warn('Placeholder could not evaluate expression: ' + this.controlData.PlaceHolder + '; ' + e);
                return '';
            }
        },
        publishField: {
            set(value){
                if(this.setValueFunction === null && this.controlData.PublishField) {
                    let vueSet = utils.helpers.convertSetValueToVueSet(this.controlData.PublishField, 'value');
                    this.setValueFunction = new Function('value', 'context', 'util', 'vue', `with (context) { ${vueSet} }`);
                }
                if(this.setValueFunction) {
                    this.setValueFunction(value, this, careHelpfulFunctions, Vue);
                }
                this.model = value;
            },
            get() {
                return this.model;
            }
        },
        isDisabled() {
            try {
                if(this.isDisabledEval === null && this.controlData.IsDisabled)
                    this.isDisabledEval = utils.compile(this, this.controlData.IsDisabled);
                if(this.isDisabledEval)
                    return utils.evaluate(this.isDisabledEval, this);
                return false;
            }
            catch (e) {
                utils.warn('IsDisabled could not evaluate expression: ' + this.controlData.IsDisabled + '; ' + e);
                return false;
            }
        },
        inputStyles() {
            return {
                ...utils.resolveStyleHints(this.styleHints, this),
            };
        },

        Text: {
            set(value) {
                this.publishField = value;
            },
            get() {
                return this.model;
            }
        },
        TextWithChange: {
            set(value) {
                this.publishField = value;

                utils.executeAndCompileAllActions(this.controlData.OnChangeActions, { Data: value }, this);
            },
            get() {
                return this.model;
            }
        },
    },
    watch: {
        model: function (newv, oldv) {
            console.log(`BasicInput [${this.RowIndex()}] model changed from '${oldv}' to '${newv}'`);
        },
    },
    methods: {
        onInput(value) {
            this.publishField = value;
        },
        async onChange() {
            await utils.executeAndCompileAllActions(this.controlData.OnChangeActions, { Text: this.model }, this);
        },
        async onBlur() {
            await utils.executeAndCompileAllActions(this.controlData.BlurActions, { Text: this.model }, this);

            // If the value actually changed, fire the OnChangeActions after the lost focus occurs
            if (this.text != this.model)
                this.onChange();
        },
        async onClear() {
            this.publishField = '';
            await utils.executeAndCompileAllActions(this.controlData.OnClearActions, null, this);
        },
        preRenderComplete() {
            this.finishRenderHandler(this);
        },
    },
    render() {
        try {
            if (!this.todisplay)
                return null;
    
            // ensure control fits within ag-grid
            const isContentDef = this.parentType === 'ContentDef';
            const containerClass = isContentDef ? 'q-ma-none q-px-xs' : 'q-ma-xs';

            return (
                <div
                    v-show={this.isvisible}
                    class={{ 'c-BasicInput': true, [`c-name-${this.name || 'unnamed'}`]: true, [containerClass]: true }}
                    style={this.sizeStyle}
                >
                    <QInput
                        id={`input-v-${this._uid}`}
                        type={this.inputType}
                        modelValue={this.model}
                        placeholder={this.placeholder}
                        style={this.inputStyles}
                        hide-bottom-space
                        dense
                        outlined
                        disable={this.isDisabled}
                        clearable={this.controlData.ShowClearIcon}
                        label={isContentDef || !this.controlData.Title ? undefined : this.Translate(this.controlData.Title)}
                        onUpdate:modelValue={(value) => { this.onInput(value); }}
                        onBlur={this.onBlur}
                        onClear={this.onClear}
                    />
                </div>
            );
        }
        catch(e) {
            utils.error('BasicInput Render failed', e);
            return <div>{this.Translate("BasicInput Failed to Render")} {e}</div>;
        }
    }
});